<template>
  <div>
    <el-dialog class="main_dialog" :title="title" :visible.sync="dialogTableVisible" width="450px">
      <!-- props中定义文件结构的数据名称 -->
      <div class="tree-box" v-loading="treeLoading">
        <el-tree default-expand-all :data="catalogue" :props="{ children: 'children', label: 'name', id: 'id' }"
          @node-click="handleNodeClick" :highlight-current="true" node-key="id" :filter-node-method="filterNode"
          ref="tree"></el-tree>
      </div>
      <!-- 按钮 -->
        <div class="folder_foot">
          <el-button size="medium" @click="newFolder">新建文件夹</el-button>
          <div style="text-align: right;">
            <el-button class="dialog_confirm" size="small" @click="sCollection">确 定</el-button>
            <el-button class="dialog_cancel" size="small" @click="dialogTableVisible = false">取 消</el-button>
          </div>
        </div>
    </el-dialog>
    <!-- 新建文件夹 -->
    <new-folder ref="newFolder" :activeID="activeID" @update="updateFolder" :showBut="false" />
  </div>
</template>
<script>
import { folderGetTree } from '@/api/material'
import NewFolder from './NewFolder';
export default {
  components: { NewFolder },
  name: "CollectionMaterialLibrary",
  props: {
    title: ""
  },
  data() {
    return {
      treeLoading: false,
      dialogTableVisible: false,
      /** 目录结构*/
      catalogue: [{
        id: 0,
        name: '全部文件',
        type: 1,
        children: null,
      }],
      activeID: 0,
      sourceList: [],
    }
  },
  methods: {
    // 筛选
    filterNode(value, data) {
      let result = value.every(item => {
        return item.id != data.id;
      })
      return result;
    },
    /* 接口方法 */
    getMaterialFolder() {
      // getMaterialFolder().then(res => {
      //   if (res.data.code == 1) {
      //     this.catalogue[0].children = res.data.data;
      //   }
      // })
      this.treeLoading = true
      folderGetTree().then(res => {
        this.catalogue[0].children = res.data
        this.treeLoading = false
      })
    },
    // 收藏
    sCollection() {
      this.dialogTableVisible = false;
      this.$emit("submit", this.sourceList, this.activeID);
    },
    /* 文件夹点击事件 */
    handleNodeClick(data) {
      this.activeID = data.id;
    },
    updateFolder() {
      this.getMaterialFolder();
    },
    // 新建文件夹
    newFolder() {
      this.$refs.newFolder.dialogTableVisible = true;
    },
    isSelected() {

    },
  },
  watch: {
    dialogTableVisible(val) {
      if (val) {
        this.getMaterialFolder();
        // this.$nextTick(() => {
        //   this.$refs.tree.filter(this.sourceList);
        // })
      }
    }
  },
  created() {
    // this.getMaterialFolder();
  },
}
</script>
<style lang="scss" scoped>
.tree-box {
  height: 360px;
  overflow-y: auto;
  .el-tree {
    background: transparent;
    // color: #fff;
    &.el-tree--highlight-current /deep/ .el-tree-node.is-current>.el-tree-node__content,
    /deep/ .el-tree-node:focus>.el-tree-node__content,
    /deep/ .el-tree-node__content:hover {
      // background: #121829;
    }
  }
}
.folder_foot {
  display: flex;
  justify-content: space-between;
//   border-top: 1px solid #f3f3f3;
//   padding-top: 16px;
}
</style>